import { useQuery } from "@tanstack/react-query";
import { contractorDetailsApi } from "../api/contractorApi";

export const useFetchPerformanceTrend = (contractorId: string | null) => {

    const { data, isFetching, isPending, isError, error, refetch } = useQuery({
        queryKey: ["contractor-performance-trend", contractorId],
        queryFn: () => contractorDetailsApi.fetchPerformanceTrend(contractorId),
        enabled: !!contractorId,
    });

    return {
        data: data,
        isLoading: isFetching || isPending,
        isError,
        error,
        refetch,
    };

};